import { useHandlerQuery } from '../../hooks/useHandlerQuery';

export const useMyBillingAccounts = () =>
  useHandlerQuery((api) => api.billing().getBillingAccounts(), {
    key: ['MY_BILLING_ACCOUNTS'],
  });
